export default __webpack_public_path__ + "static/media/img_step_lucia01_w.ae7e7c58.jpg";